export default {
    name: 'ClientView'
}